export function formatPhone(number) {
  if(!number){
    return ""
  }
  return String(number).replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
}
